import '../scss/main.scss';
import '../scss/work-entry.scss';
import './_common.js';
